import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { RECORDS } from "../../SMS_country.json";
import "./selectCountry.scss";

export const CountrySelect = ({
  selectAreaHandler,
  getAreaItem,
}) => {
  useEffect(() => {
    initLetterList();
  }, []);
  const {t} = useTranslation()
  const country = RECORDS;
  const sortedData = country.sort((a, b) => {
    const a1 = a.pinYinIndex;
    const b1 = b.pinYinIndex;
    return a1.localeCompare(b1); // 使用 localeCompare() 方法进行字符串比较
  });
  const groupedData = sortedData.reduce(
    (acc, obj) => {
      const firstLetter = obj.pinYinIndex.toUpperCase();
      if (!acc[firstLetter]) {
        acc[firstLetter] = [];
      }
      acc[firstLetter].push(obj);
      return acc;
    },
    {}
  );
  const result = Object.values(groupedData);
  const initLetterList = () => {
    const letterListWrap = document.getElementById("letter-list-wrap");
    let ele = null;
    letterListWrap?.addEventListener("touchmove", function (e) {
      e.preventDefault();
      const X = e.touches[0].clientX;
      const Y = e.touches[0].clientY;

      ele = document.elementFromPoint(X, Y);
      const letterSpanList = letterListWrap?.children;
      if (letterSpanList) {
        for (let i = 0; i < letterSpanList?.length; i++) {
          letterSpanList[i].classList.remove("letterSpan");
        }
      }
      ele?.setAttribute("letterMyChart", ele.innerHTML);
      ele?.classList.add("letterSpan");

      const eleContent = ele?.innerHTML;

      checkRightLetter(eleContent);
    });
    letterListWrap?.addEventListener("touchend", function (e) {
      e.preventDefault();
      ele?.classList.remove("letterSpan");
      letterListWrap?.removeEventListener("touchmove", initLetterList, false);
    });
  };
  const checkRightLetter = (item) => {
    const id = document.getElementById("country-" + item);
    if (id) {
      id.scrollIntoView({ block: "start", behavior: "auto" });
    }
  };
  const selectItem = (item) => {
    selectAreaHandler(false);
    getAreaItem(item)
    return false;
  };
  return (
    <>
      <div className="outBox">
        <div className="leftBox">
          {result.map((item, index) => {
            return (
              <div
                key={"" + index}
                className="wrap"
                id={`country-${item[0].pinYinIndex}`}
              >
                <div className="wrapTitle">
                  {item[0].pinYinIndex.toUpperCase()}
                </div>
                {item.map((v, i) => {
                  return (
                    <div
                      key={"v" + i}
                      className="wrapContent"
                      onClick={() => selectItem(v)}
                    >
                      {t(v.country)}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
        {/* <div className="rightBox" id="letter-list-wrap">
          {result.map((item, pinYinIndex) => {
            return (
              <span
                onClick={() => {
                  checkRightLetter(item[0].v);
                }}
                key={"l" + pinYinIndex}
              >
                {item[0].pinYinIndex}
              </span>
            );
          })}
        </div> */}
      </div>
    </>
  );
};